import {
  FETCH_CARTS,
  PUSH_CARTS,
  UPDATE_CARTS,
  REMOVE_CARTS,
  CLEAR_CARTS,
 } from '../actions/cartsActions';
 import cloneDeep from "lodash/cloneDeep"

const INITIAL_STATE = {
  data: [],
}

export default function cartsReducer(state = INITIAL_STATE, action){
  switch(action.type){
    case FETCH_CARTS:
      return {
        ...state,
        data:action.data,
      }
    case PUSH_CARTS:
      // let findInCarts = find(state.data, { 'productId': action.data._id })
      // if(findInCarts){
      //     let updated = state.data.map((v)=>{
      //         if(v.productId === action.data._id) {
      //           let productQuantity = (v.quantity + (action.quantity))
      //           v.quantity = productQuantity
      //           v.totalNetAmount = v.perUnitAmount*(productQuantity)
      //           return v
      //         } else return v
      //     })
      //     return {
      //         ...state,
      //         data:updated,
      //     }
      // }else{
          let addtoCarts = {
            productId: action.data._id,
            productCode: action.data.code,
            productImg: action.data.productImg[0]?action.data.productImg[0].fileUrl:'',
            name: action.data.name,
            quantity: (action.quantity),
            // USD amounts
            totalNetAmount: action.data.netAmount*(action.quantity),
            oriTotalNetAmount: action.data.netAmount*(action.quantity),
            perUnitAmount: action.data.netAmount,
            oriPerUnitAmount: action.data.netAmount,
            // MYR amounts
            totalNetAmountMYR: action.data.netAmountMYR*(action.quantity),
            oriTotalNetAmountMYR: action.data.netAmountMYR*(action.quantity),
            perUnitAmountMYR: action.data.netAmountMYR,
            oriPerUnitAmountMYR: action.data.netAmountMYR,
            // Discount
            discountAmount: 0,
            discountAmountPerUnit: 0,
            discountAmountMYR: 0,
            discountAmountPerUnitMYR: 0,
            variations: action.data.variations?
              (action.data.variations.length > 0?
                cloneDeep(action.data.variations).filter(element => {
                  if(element.selected){
                    // USD
                    element.totalAmount = element.amount*(action.quantity)
                    element.oriTotalAmount = element.amount*(action.quantity)
                    element.oriAmount = element.amount
                    element.discountAmount = 0
                    element.discountAmountPerUnit = 0
                    // MYR
                    element.totalAmountMYR = element.amountMYR*(action.quantity)
                    element.oriTotalAmountMYR = element.amountMYR*(action.quantity)
                    element.oriAmountMYR = element.amountMYR
                    element.discountAmountMYR = 0
                    element.discountAmountPerUnitMYR = 0
                    return element
                  }else{return false}
                })
                :[])
            :[],
            localShippingAmount: action.data.localShippingAmount,
            packageHeight: action.data.packageHeight,
            packageLength: action.data.packageLength,
            packageWeight: action.data.packageWeight,
            packageWidth: action.data.packageWidth
          }
          return {
              ...state,
              data:[addtoCarts, ...state.data],
          }
      // }
    case UPDATE_CARTS:
      let updated = state.data.map((v, i)=>{
        if(i === action.index) {
          let productQuantity = 0
          if(action.symbol === "+"){
            productQuantity = (v.quantity + (action.quantity))
          }else{
            productQuantity = (v.quantity - (action.quantity))
          }
          v.quantity = productQuantity
          // USD
          v.totalNetAmount = v.perUnitAmount*(productQuantity)
          v.oriTotalNetAmount = v.oriPerUnitAmount*(productQuantity)
          // MYR
          v.totalNetAmountMYR = v.perUnitAmountMYR*(productQuantity)
          v.oriTotalNetAmountMYR = v.oriPerUnitAmountMYR*(productQuantity)
          v.variations = v.variations?
              (v.variations.length > 0?
                cloneDeep(v.variations).filter(element => {
                  if(element.selected){
                    // USD
                    element.totalAmount = element.amount*(productQuantity)
                    element.oriTotalAmount = element.oriAmount*(productQuantity)
                    // MYR
                    element.totalAmountMYR = element.amountMYR*(productQuantity)
                    element.oriTotalAmountMYR = element.oriAmountMYR*(productQuantity)
                    return element
                  }else{return false}
                })
                :[])
            :[]
          return v
        } else return v
      })
      return {
          ...state,
          data:updated,
      }
    case REMOVE_CARTS:
      return {
        ...state,
        data: [...state.data.filter( (item, index) => index !== action.index)]
      }
    case CLEAR_CARTS:
      return {
        ...state,
        data: []
      }
    default:
      return state

  }
}